import {action, makeAutoObservable, observable} from 'mobx';
import LineInterface from 'app/interfaces/LineInterface';
import GamerInterface from 'app/interfaces/GamerInterface';

export type QuickBetLinePayload = LineInterface;
export type QuickBetLinePatch = Partial<LineInterface>;
type PatchableKey = Extract<keyof QuickBetLineModel, keyof LineInterface>;

const PATCH_KEYS: PatchableKey[] = [
    'coef_1',
    'coef_2',
    'color',
    'date',
    'live',
    'status',
    'game',
    'game_slug',
    'game_id',
    'game_label',
    'label_type',
    'gamer_1',
    'gamer_2',
    'ut',
    'streams',
    'streams_enabled',
    'esports',
    'deleted',
    'hidden',
    'filter',
    'quick_timer_end_at'
];

export class QuickBetLineModel {
    id: number;

    coef_1: string;

    coef_2: string;

    color: number;

    date: number;

    live: boolean;

    status: number;

    game: string;

    game_slug: string;

    game_id: number;

    game_label: string | undefined;

    label_type: number;

    gamer_1: GamerInterface;

    gamer_2: GamerInterface;

    ut: number;

    streams: number[];

    streams_enabled: boolean;

    esports: boolean;

    deleted: boolean;

    hidden: boolean;

    filter: number;

    quick_timer_end_at: number;

    raw: LineInterface;

    placedGamer: number | null = null;

    constructor(payload: QuickBetLinePayload) {
        this.id = payload.id;
        this.applyPatch(payload);
        this.ut = payload.ut ?? 0;
        this.raw = payload;

        makeAutoObservable(this, {raw: observable.ref});
    }

    @action
    updateFromPatch(patch: QuickBetLinePatch): void {
        this.applyPatch(patch);

        const definedPatch = Object.fromEntries(
            Object.entries(patch).filter(([, v]) => typeof v !== 'undefined')
        ) as QuickBetLinePatch;

        this.raw = {...this.raw, ...definedPatch};
    }

    @action
    setPlacedGamer(gamer: number | null): void {
        this.placedGamer = gamer;
    }

    private applyPatch(patch: QuickBetLinePatch): void {
        for (const key of PATCH_KEYS) {
            if (key in patch) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (this as any)[key] = patch[key];
            }
        }
    }
}
